import axios from "axios";

// const URL_V2 = 'http://eposter-api.entwicklung:8030/api/v2';
const URL_V2 = 'https://'+ process.env.VUE_APP_CONGRESS_SHORT +'.eposter.documedias.systems/api/v2';
export default {
  namespaced: true,

  state: {
    sortField: 'title',
    sortOrder: 'asc'
  },
  actions: {},
  mutations: {
    setSortField(state, sortField) {
      state.sortField = sortField;
    },
    setSortOrder(state, sortOrder) {
      state.sortOrder = sortOrder;
    },
  },
  getters: {}
}
